import moment from 'moment';
import dayjs from 'dayjs';

const FORMATS = {
  DATE: 'DD/MM/YYYY',
  DATE_WITH_TIME: 'DD/MM/YYYY HH:mm:ss',
  TIME_WITHOUT_DATE: 'HH:mm:ss',
};

export function serverDateToDateWithTime(date) {
  if (!date) {
    return null;
  }

  return moment(date).format(FORMATS.DATE_WITH_TIME);
}

export function serverDateToDate(date) {
  if (!date) {
    return null;
  }

  return moment(date).format(FORMATS.DATE);
}

export function serverDateToTimeWithoutDate(date) {
  if (!date) {
    return null;
  }

  return moment(date).format(FORMATS.TIME_WITHOUT_DATE);
}

export function unixToMoment(unix) {
  return (+unix && moment(+unix)) || null;
}

export function unixToDayjs(unix) {
  return (+unix && dayjs(+unix)) || null;
}

export function momentToUnix(v) {
  return (v && v.valueOf()) || null;
}

export function unixFromNow(unix, startUnix = null) {
  if (!unix) return null;

  return timeSince(moment(startUnix && +startUnix).unix() - moment(+unix).unix());
}

function timeSince(sec) {
  const sec_num = parseInt(sec, 10);
  const hours = Math.floor(sec_num / 3600);
  const minutes = Math.floor(sec_num / 60) % 60;
  const seconds = sec_num % 60;
  // const arr = ['h', 'm', 's'];

  return `${hours !== 0 ? (hours < 10 ? '0' + hours + 'h ' : hours + 'h ') : ''}${minutes !== 0 ? (minutes < 10 ? '0' + minutes + 'm ' : minutes + 'm ') : ''}${seconds !== 0 ? (seconds < 10 ? '0' + seconds + 's ' : seconds + 's ') : ''}`
  // return [hours, minutes, seconds]
  //   .map(v => v < 10 ? '0' + v : v)
  //   .reduce((acc, cur, i) => `${acc} ${cur}${arr[i]} `, '');
}

export function getLastWeekRange() {
  return [
    moment
      .utc()
      .subtract(1, 'week')
      .startOf('week'),
    moment
      .utc()
      .subtract(1, 'week')
      .endOf('week'),
  ];
}

export function getLastMonthRange() {
  return [
    moment
      .utc()
      .subtract(1, 'month')
      .startOf('month'),
    moment
      .utc()
      .subtract(1, 'month')
      .endOf('month'),
  ];
}

function getLast30DaysRange() {
  const currentDate = moment.utc();
  const startDate = moment.utc(currentDate).subtract(1, 'month'); // Same day last month
  return [startDate, currentDate];
}

export function dateRangePeriods() {
  return {
    'Last Week': getLastWeekRange(),
    'Last Month': getLastMonthRange,
    Today: [moment.utc().startOf('day'), moment.utc().endOf('day')],
    'This Week': [moment.utc().startOf('week'), moment.utc().endOf('week')],
    'This Month': [moment.utc().startOf('month'), moment.utc().endOf('month')],
    'Last 30 Days': getLast30DaysRange()
  };
}

export function momentToUnixRange(arr) {
  if (!arr) {
    return [null, null];
  }

  const [from, to] = arr;

  return [
    (from && from.startOf('day').valueOf()) || null,
    (to && to.endOf('day').valueOf()) || null,
  ];
}


export function getCurrentDates() {
  const currentDate = dayjs();
  const currentMilliseconds = currentDate.valueOf();

  const previousMonthDate = currentDate.subtract(1, 'month');
  const previousMonthMilliseconds = previousMonthDate.valueOf();

  return [previousMonthMilliseconds, currentMilliseconds];
}

